import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
//import VueI18n from 'vue-i18n';
import router from './router'
import mensajero from './components/utils/mensajero'
import getters from './components/utils/getters'
import setters from './components/utils/setters'
import fechero from './components/utils/fechero'
import repository from './components/utils/repository'
import Breadcrumbs from './components/bread_crumbs'
import { store } from './store';
import VueAxios from 'vue-axios'
import { securedAxiosInstance, plainAxiosInstance } from './backend/axios'
import moment from 'moment'
//import firebase from 'firebase/app';
//import Vue2Filters from 'vue2-filters'
import VueSweetalert2 from 'vue-sweetalert2';
//import VueFormWizard from 'vue-form-wizard';
//import VueTour from 'vue-tour'
//import Notifications from 'vue-notification'
import { Vue2Dragula } from 'vue2-dragula'
import Toasted from 'vue-toasted';
//import SmartTable from 'vuejs-smart-table'
//import * as VueGoogleMaps from 'vue2-google-maps'
//import { VueMasonryPlugin } from 'vue-masonry'
//import VueProgressBar from 'vue-progressbar'
import VueFeather from 'vue-feather';
import 'vuetify/dist/vuetify.min.css'
import Vuetify from 'vuetify'
import VueSplit from 'vue-split-panel'
import FileSelector from 'vue-file-selector';
//import DisableAutocomplete from 'vue-disable-autocomplete';
//Vue.use(DisableAutocomplete);

Vue.use(VueSplit)
Vue.use(FileSelector);
//import { Icon } from "leaflet";
//delete Icon.Default.prototype._getIconUrl;

//import en from "./locales/en.json"
//import es from "./locales/es.json"

// Import Theme scss
import './assets/scss/app.scss'

/*Icon.Default.mergeOptions({
  //iconRetinaUrl: require("./assets/images/vue2leaflet/marker-icon.png"),
  iconUrl: require("./assets/images/vue2leaflet/marker-icon.png")
});*/

Vue.mixin(mensajero);
Vue.mixin(getters);
Vue.mixin(setters);
Vue.mixin(fechero);
Vue.mixin(repository);
Vue.use(VueFeather);

//Vue.use(VclFacebook)
//Vue.use(VclInstagram)

/*Vue.use(DaySpanVuetify, {
  methods: {
    getDefaultEventColor: () => '#1976d2'
  }
});*/

/*Vue.use(VueProgressBar, {
  color: 'rgb(0, 161, 211)',
  failedColor: 'red',
  height: '1px'
})*/

//Vue.use(VueI18n);
//const messages = { en: en, es:es };
//import {defaultLocale,localeOptions} from './constants/config'
/*const locale =(localStorage.getItem('language') && localeOptions.filter(x=>x.id==localStorage.getItem('language')).length>0) ? localStorage.getItem('language') : defaultLocale
const i18n = new VueI18n({
  locale:locale,
  fallbackLocale:'en',
  messages
})*/

Vue.use(Toasted,{
  iconPack: 'fontawesome'
});
Vue.use(Vue2Dragula);

Vue.use(VueAxios, {
  secured: securedAxiosInstance,
  plain: plainAxiosInstance,
  //gdrive: gdriveAxiosInstance
})

/*Vue.use(VueGoogleMaps, {
  load: {
    key: 'API_KEY',
    libraries: 'places',
  },
})*/

require('moment-timezone');
Vue.use(require('vue-moment'), {
  moment
})

//Vue.use(Notifications)
//Vue.use(Vue2Filters)

const swal_options = {
  confirmButtonColor: '#0092d2',
  cancelButtonColor: '#808080',
};

Vue.use(VueSweetalert2, swal_options);

//Vue.use(VueFormWizard)
//Vue.use(VueTour)
Vue.use(BootstrapVue)
//Vue.use(SmartTable)
Vue.use(require('vue-chartist'))
//Vue.use(require('vue-moment'));
Vue.component('Breadcrumbs', Breadcrumbs)
//Vue.use(VueMasonryPlugin)


Vue.use(Vuetify)

Vue.filter('formatMoney', function(amount) {
  try {
    if (amount) {
      const negativeSign = amount < 0 ? "-" : "";
      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(2)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;
      return negativeSign + (j ? i.substr(0, j) + "," : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + ",") + (2 ? "." + Math.abs(amount - i).toFixed(2).slice(2) : "");
    } else {
      return "0.00"
    }
  } catch (error) {
    return "0.00"
  }
});

Vue.config.productionTip = false
/*var config = {
  apiKey: "Your API Key",
  authDomain: "Your AuthDomain",
  databaseURL: "Your DatabaseURL",
  projectId: "Your ProjectId",
  storageBucket: "Your Storage Bucket",
  messagingSenderId: "Your Messaging SenderId"
};
firebase.initializeApp(config);
export const db = firebase.firestore();
*/

new Vue({
  router,
  store,
  //i18n,
  securedAxiosInstance,
  plainAxiosInstance,
  render: h => h(App)
}).$mount('#app')
